module.exports = __webpack_public_path__ + "static/img/cover.a213cf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/cover.jpg
// module id = j7Fy
// module chunks = 1